/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Children_P1Inputs */

const es_privacy_policy_children_p1 = /** @type {(inputs: Privacy_Policy_Children_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata no esta dirigida a ninos menores de 13 anos. No recopilamos intencionalmente informacion personal de menores de dicha edad.`)
};

const en_privacy_policy_children_p1 = /** @type {(inputs: Privacy_Policy_Children_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata is not directed at children under 13. We do not intentionally collect personal information from individuals under that age.`)
};

/**
* | output |
* | --- |
* | "Nexata is not directed at children under 13. We do not intentionally collect personal information from individuals under that age." |
*
* @param {Privacy_Policy_Children_P1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_children_p1 = /** @type {((inputs?: Privacy_Policy_Children_P1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Children_P1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_children_p1(inputs)
	return en_privacy_policy_children_p1(inputs)
});
export { privacy_policy_children_p1 as "privacy_policy.children.p1" }